import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
export const Title = styled.h1`
  font-family: 'Poppins';
  font-weight: bold;
  color: #ffffff;
  font-size: 24px;
  margin-bottom: 16px;
  text-align: center;

  & br {
    display: none;
  }

  // Large devices (desktops, 992px and up)
  @media (min-width: 992px) { 
    font-size: 40px;
    margin-bottom: 26px;

    & br {
      display: block;
    }
  }
  // X-Large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) { 
    font-size: 40px;
    margin-bottom: 26px;

    & br {
      display: block;
    }
  }
  // XX-Large devices (larger desktops, 1400px and up)
  @media (min-width: 1400px) { 
    font-size: 40px;
    margin-bottom: 26px;
    
    & br {
      display: block;
    }
  }
`;
export const Subtitle = styled.h2`
  font-family: 'Poppins';
  font-weight: normal;
  color: #ffffff;
  font-size: 14px;
  margin-bottom: 4px;
  text-align: center;

  & br {
    display: none;
  }

  // Large devices (desktops, 992px and up)
  @media (min-width: 992px) { 
    font-size: 16px;

    & br {
      display: block;
    }
  }
  // X-Large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) { 
    font-size: 16px;

    & br {
      display: block;
    }
  }
  // XX-Large devices (larger desktops, 1400px and up)
  @media (min-width: 1400px) { 
    font-size: 16px;
    
    & br {
      display: block;
    }
  }
`;
export const ClickTitle = styled.button`
  font-family: 'Poppins';
  font-weight: 500;
  color: #F9BD36;
  font-size: 14px;
  width: max-content;
  background-color: transparent;
  border: 0;
   
  & svg {
    font-size: 18px;
  }
`;